import { NavIconBadge } from "@/components/ui/NavIconBadge";
import {
	AGENT_LAYER_SLOGAN,
	ALL_SECTIONS,
	PLATFORM_NAME,
	ROUTES,
} from "@/lib/routes";
import { cn } from "@/lib/utils";
import { Zap } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Full section catalog — premium icon badges + glass more-cards.
 * Agent Layer uses dedicated black/yellow mono chrome (more-card--agent).
 * Skills + Intelligence are Agent Layer–only (not listed here).
 */
export default function MorePage() {
	return (
		<div className="container mx-auto space-y-5 px-4 py-8 pb-16">
			<p className="section-eyebrow">More</p>
			<h1 className="font-display text-xl font-bold sm:text-2xl">
				{PLATFORM_NAME} sections
			</h1>
			<p className="max-w-xl text-sm text-muted-foreground">
				All product surfaces. Use Ask AI → Go or ⌘K to jump quickly. Connect is
				in the top bar. Skills and Intelligence live under Agent Layer.
			</p>

			<ul className="grid grid-cols-1 items-stretch gap-3 sm:grid-cols-2 lg:grid-cols-3">
				{ALL_SECTIONS.map((s) => {
					const isAgent = s.to === ROUTES.agents;
					return (
						<li key={s.to + s.label} className="min-h-0">
							<Link
								to={s.to}
								className={cn("more-card", isAgent && "more-card--agent")}
							>
								{isAgent ? (
									<span
										className="nav-icon-badge flex size-11 shrink-0 items-center justify-center rounded-xl border"
										aria-hidden
									>
										<Zap className="size-5" />
									</span>
								) : (
									<NavIconBadge icon={s.icon} size="md" />
								)}
								<span className="flex min-w-0 flex-1 flex-col">
									{isAgent && (
										<span className="more-card__eyebrow mb-0.5 text-[10px] font-bold uppercase tracking-[0.14em]">
											AGENT LAYER
										</span>
									)}
									<span
										className={cn(
											"more-card__label truncate text-sm font-semibold",
											!isAgent && "text-foreground",
										)}
									>
										{s.label}
									</span>
									<span
										className={cn(
											"more-card__desc mt-1 line-clamp-2 min-h-[2.5rem] text-[11px] leading-snug",
											!isAgent && "text-muted-foreground",
										)}
									>
										{isAgent ? AGENT_LAYER_SLOGAN : s.desc}
									</span>
									{isAgent && (
										<span className="more-card__label mt-1 text-[10px] font-bold uppercase tracking-wide">
											Enter Agent Layer →
										</span>
									)}
								</span>
							</Link>
						</li>
					);
				})}
			</ul>
		</div>
	);
}
